import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import { useTranslation } from "react-i18next";
import PointieBox from "../../../components/PointieBox";
import PointieTypography from "../../../components/PointieTypography";

const FeatureHighlights = () => {
  const { t } = useTranslation("home");

  const features = [
    {
      icon: "bolt",
      title: t("featureHighlights.feature1Title"),
      desc: t("featureHighlights.feature1Desc"),
      color: "#EF6C00",
    },
    {
      icon: "compare_arrows",
      title: t("featureHighlights.feature2Title"),
      desc: t("featureHighlights.feature2Desc"),
      color: "#D32735",
    },
    {
      icon: "trending_up",
      title: t("featureHighlights.feature3Title"),
      desc: t("featureHighlights.feature3Desc"),
      color: "#7B2DC0",
    },
  ];

  return (
    <PointieBox component="section" py={4}>
      <Container>
        <PointieTypography variant="h3" textAlign="center" mb={1}>
          {t("featureHighlights.title")}
        </PointieTypography>
        <PointieTypography variant="body2" color="text" textAlign="center" mb={4}>
          {t("featureHighlights.subtitle")}
        </PointieTypography>
        <Grid container spacing={4}>
          {features.map((f) => (
            <Grid item xs={12} md={4} key={f.icon}>
              <PointieBox
                sx={{
                  p: 3,
                  borderRadius: 2,
                  border: "1px solid #eee",
                  height: "100%",
                  transition: "all 0.2s",
                  "&:hover": {
                    boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                    transform: "translateY(-4px)",
                  },
                }}
              >
                <PointieBox
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    bgcolor: f.color,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2,
                  }}
                >
                  <Icon sx={{ color: "#fff", fontSize: 24 }}>{f.icon}</Icon>
                </PointieBox>
                <PointieTypography variant="h5" component="h4" mb={1}>
                  {f.title}
                </PointieTypography>
                <PointieTypography variant="body2" color="text">
                  {f.desc}
                </PointieTypography>
              </PointieBox>
            </Grid>
          ))}
        </Grid>
      </Container>
    </PointieBox>
  );
};

export default FeatureHighlights;
